import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { AppShell } from "@1823-partners/core";
import api from "./api";
import Dashboard from "./components/Dashboard";
import PortfolioAnalysis from "./components/PortfolioAnalysis";
import { SITE_ENV } from "./utils/siteEnv";

export default function App() {
  const [currentTab, setCurrentTab] = useState(0);
  const [prefilledAnalysisData, setPrefilledAnalysisData] = useState(null);

  const handleLoadAnalysis = (configData) => {
    const analysisData = {
      id: configData.ID || null,
      cusips: configData.CUSIPS ? configData.CUSIPS.split(',').map(c => c.trim()) : [],
      asofdt: configData.ASOFDT || '',
      env: configData.ENV || SITE_ENV,
      scenarios: configData.SCEN_IDS ? configData.SCEN_IDS.split(',').map(s => s.trim()) : [],
      description: configData.DESCRIPTION || '',
      adcoCshfBond: Boolean(configData.ADCO_CSHF_BOND),
      adcoCshfLoan: Boolean(configData.ADCO_CSHF_LOAN),
      // Saving or running this config from the form edits it, which needs the
      // MODIFIED_DATE it was loaded with.
      modifiedDate: configData.MODIFIED_DATE ?? null,
    };
    setPrefilledAnalysisData(analysisData);
    setCurrentTab(1);
  };

  return (
    <AppShell appName="scenarios" permissionPrefix="scenario" title="Scenarios" api={api}>
      {({ userInfo }) => (
        <Box>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
            <Tabs value={currentTab} onChange={(_, v) => setCurrentTab(v)}>
              <Tab label="Dashboard" />
              <Tab label="Portfolio Analysis" />
            </Tabs>
          </Box>
          {currentTab === 0 && (
            <Dashboard
              userId={userInfo?.userDetails}
              onLoadAnalysis={handleLoadAnalysis}
            />
          )}
          {currentTab === 1 && (
            <PortfolioAnalysis
              userId={userInfo?.userDetails}
              prefilledData={prefilledAnalysisData}
              onDataUsed={() => setPrefilledAnalysisData(null)}
            />
          )}
        </Box>
      )}
    </AppShell>
  );
}
